module.exports = __webpack_public_path__ + "img/partner_mo1.b30926cc.png";